import axios from "axios";
import { APP_3D_API_URL } from "../utils/constants";

export const getRecentProjects = () => {
  return axios.get(APP_3D_API_URL + "/projects/recent", {
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: localStorage.getItem("__Secure-floorplanner_token"),
    },
  });
};

export const updateRotation = (values) => {
  return axios.post(APP_3D_API_URL + "/project/rotate", values, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: localStorage.getItem("__Secure-floorplanner_token"),
    },
  });
};

export const processProject = (values) => {
  return axios.post(APP_3D_API_URL + "/project/process", values, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: localStorage.getItem("__Secure-floorplanner_token"),
    },
  });
};
